import { render, staticRenderFns } from "./banner-web.vue?vue&type=template&id=b51689f0&scoped=true"
import script from "./banner-web.vue?vue&type=script&lang=js"
export * from "./banner-web.vue?vue&type=script&lang=js"
import style0 from "./banner-web.vue?vue&type=style&index=0&id=b51689f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51689f0",
  null
  
)

export default component.exports